// import Accordion from '../../plugins/accordion.js';
// const elements = document.querySelectorAll(".js-accordion");
// for (const element of elements) {
//   let accordion1 = new Accordion(element, {
//     defaultOpenPanels: [0],
//     multipleOpen: true,
//     onOpen: test,
//     onClose: fuga
//   });
// }


// let accordion = new Accordion(".js-accordion2", {
//   defaultOpenPanels: [0],
//   onOpen: hoge,
//   onClose: fuga
// });

// function test(trigger, panel){
  // trigger.style.color = '#f00'
// }
// function fuga(trigger, panel){
  // trigger.style.color = '#000'
// }

// accordion.destroy()
// accordion.init()

const details = document.querySelector(".c-accordion__item");
const summary = document.querySelector(".c-accordion__header");

if(summary){
summary.addEventListener("click", (event) => {
  // 連打防止用。アニメーション中だったらクリックイベントを受け付けないでリターンする
  if (details.dataset.animStatus === "running") {
    return;
  }

  // detailsのopen属性を判定
  if (details.open) {
    // ...略
    // アニメーション実行中用の値を付与
    details.dataset.animStatus = "running";

    closingAnim.onfinish = () => {
      // アニメーションの完了後に値を取り除く
      details.dataset.animStatus = "";
    };
  } else {
    // ...略
    // アニメーション実行中用の値を付与
    details.dataset.animStatus = "running";

    openingAnim.onfinish = () => {
      // アニメーションの完了後に値を取り除く
      details.dataset.animStatus = "";
    };
  }
});
}